export const MUTATION_IMPORT_PRODUCTS = `mutation importProducts($products:[ProductImportInput!]!){
  importProducts(products: $products)
}`